import { instance } from "@/api/index";

export const listPlan = () => instance.get("/back/plan"); // 일정 조회
export const listPlanDetail = id => instance.get(`/back/plan/${id}`); // 일정 상세조회
export const setPlan = payload => instance.post("/back/plan", payload); // 일정 등록
export const modiPlan = (id, payload) =>
  instance.put(`/back/plan/${id}`, payload); // 일정 수정
export const delPlan = planNo => instance.delete(`/back/plan/${planNo}`); // 일정 삭제
export const planSelect = params =>
  instance.get(`/back/common?params=${params}`); // 일정구분, 사원, 프로젝트 조회
// planTy,emp,prj
